import ProfileEntity from '@/entities/Profile'
import ProfileRepository from '@/repositories/ProfileRepository'

export interface IPresenterParams {
  profileRepository: ProfileRepository
}

export interface IPresenter {
  profile: ProfileEntity | null
}

export default ({ profileRepository }: IPresenterParams): IPresenter => {
  const profile = profileRepository.getProfile()

  return {
    profile
  }
}
